import RoadworkIcon from '@/components/icons/RoadworkIcon.vue';
import GatheringIcon from '@/components/icons/GatheringIcon.vue';
import StageIcon from '@/components/icons/StageIcon.vue';
import FireIcon from '@/components/icons/FireIcon.vue';
import RoadblockIcon from '@/components/icons/RoadblockIcon.vue';
import CarIcon from '@/components/icons/CarIcon.vue';
import Accident from '@/components/icons/AccidentIcon.vue';

export default class FlatIcons {
  public static getIcons() {
    return {
      roadwork: {
        component: RoadworkIcon,
        props: {
          color: String
        }
      },
      gathering: {
        component: GatheringIcon
      },
      stage: {
        component: StageIcon
      },
      fire: {
        component: FireIcon
      },
      roadblock: {
        component: RoadblockIcon
      },
      car: {
        component: CarIcon
      },
      accident: {
        component: Accident
      }
    }
  }
}
